<template>
    <div class="container" id="footer">
        <div class="row">
            <div class="col-12 col-md-4  col-lg-3 ">
                <div class="footer-logo">
                    <a href="index.html">
                        <img src="@/html/elements/logo-vertical-flaubert.png" alt="">
                    </a>
                </div>
            </div>

            <div class="col-12 col-md-3 col-lg-4 order-first order-lg-3 footer-info">

                <p class="mb-4">
                    1 rue albert Dupuis<br>
                    76044 Rouen Cedex
                </p>
                <ul class="footer-links">
                    <li>
                        <a href="#">Toutes les actualités</a>
                    </li>
                    <li>
                        <a href="#">L'Agenda</a>
                    </li>
                    <li>
                        <a href="contact">Contact</a>
                    </li>
                    <li>
                        <a href="https://connexion.l-educdenormandie.fr/" target="new">Accès ENT</a>
                    </li>
                </ul>
                <!-- <div class="footer-social">
                   <a href="#"><img src="@/html/elements/facebook.svg" alt=""></a>
                   <a href="#"><img src="@/html/elements/linkedin.svg" alt=""></a>
                </div> -->
            </div>
            
            <div class="col-12 col-md-6 col-lg-5 order-first order-lg-3 footer-info">
                <h5 class="c-1"><span>Lycée Général et Technologique</span></h5>
                <div class="footer-tel c-1">
                    <div>
                        <img src="@/html/elements/call.svg" alt="">
                        <a href="tel:0235128888">02 35 12 88 88</a>
                    </div>
                    <div>
                        <a href="mailto:ce.0760096s@ac-normandie.fr">
                            <img src="@/html/elements/email.svg" alt="">
                        </a>
                    </div>
                </div>
                <h5 class="c-2"><span>Lycée Professionnel</span></h5>
                <div class="footer-tel c-2">
                    <div>
                        <img src="@/html/elements/call.svg" alt="">
                        <a href="tel:0235128846">02 35 12 88 46</a>
                    </div>
                    <div>
                        <a href="mailto:ce.0760142s@ac-normandie.fr">
                            <img src="@/html/elements/email.svg" alt="">
                        </a>
                    </div>
                </div>

                <h5 class="c-3"><span>Flaubert SUP</span></h5>
                <div class="footer-tel c-3">
                    <div>
                        <img src="@/html/elements/email.svg" alt="">
                        <a href="tel:0235128887">ce.0760096s@ac-normandie.fr</a>
                    </div>
                    <div>
                        <!-- <a href="mailto:ce.0760096s@ac-normandie.fr">
                            <img src="@/html/elements/email.svg" alt="">
                        </a> -->
                    </div>
                </div>
                <!-- <div class="footer-social">
                   <a href="#"><img src="@/html/elements/facebook.svg" alt=""></a>
                   <a href="#"><img src="@/html/elements/linkedin.svg" alt=""></a>
                </div> -->
            </div> 
        </div>
        <div class="row">
            <div class="col-12 copyright">
                <p>Copyright © 2020 <a href="https://www.lycee-flaubert-rouen.fr/">LYCEE GUSTAVE FLAUBERT</a> - Tous droits réservés. Réalisation : <a class="white-link" href="https://www.devinfluence.fr">DEV'INFLUENCE</a></p>
                <p><a class="white-link" href="mentions-legales">Mentions Légales</a> | <a class="white-link" href="contact">Contact</a></p>
            </div>
        </div>
    </div>
</template>


<script>

// FIREBASE
import "firebase/auth";
const firebase = require("firebase");
require("firebase/firestore");
require("firebase/auth");
var db = firebase.firestore();
import { firebaseConfig } from "@/firebase/firebaseConfig";

export default {
    name: "esp-header",
    props: {
        dataPage:{
            type: Object
        }
    },
    data() {
        return {
          
        }
    },
    computed:{
        customizableVar1: function () {
            if(this.dataPage.customizableVar[0].value.value){
                return this.dataPage.customizableVar[0].value.value
            }else{
                return "0f555d"
            }
        }
    },
    methods: {
        formatLabelMenu(str) {
            return str.replace("<br>"," ")
            
        },
        getSrcMenuPage(idPage) {
            let page = this.$parent.dataIris.pages.find(page => page.id === idPage) 
            
            return require('@/html/elements/o-'+page.customizableVar[0].value.value+'.svg')
        }
    }
}
</script>
<style>
#footer {
    font-size: 0.75rem;
    color: #ffffff;
    text-transform: none;
    position: relative;
    background-color: transparent;
    margin-top: 40px;
    font-size:0.8rem;
    padding-top:3rem
}
#footer::before{
    content:"";
    background-color: #333333;
    width: 10000px;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: -1;
}
#footer::after {
    content:"";
    background-color: #333333;
    width: 120px;
    height: 100%;
    position: absolute;
    top: 0;
    border-top-right-radius:120px;
    z-index: -1;
}
#footer::before {
    right: 90px;
}
#footer::after {
    right: -30px;
}

#footer a{
    color:#d17335;
}
#footer a:hover{
    color:#d1733560;
    text-decoration: none;
}

#footer .footer-logo{
    margin:0px 0px 40px 0px
}
#footer .footer-logo img{
    max-width: 100%;
}

#footer .footer-info{
    font-size: 1.3rem;
    font-weight: 400;
}
#footer .footer-info h5{
    overflow: hidden;
    font-weight: 400;
    margin-top:0rem;
    padding-left:1rem;
}
#footer .footer-info h5 span{
    width: max-content;
    position: relative;
}
#footer .footer-info h5 span:after{
    content:"";
    background-color: #d17335;
    width: 400%;
    height: 2px;
    position: absolute;
    top: 50%;
    right:calc(-400% - 10px);
    border-top-left-radius:4px;
    border-bottom-left-radius:4px
}
#footer .footer-info h5 span:before{
    content:"";
    background-color: #d17335;
    width: 8px;
    height: 8px;
    position: absolute;
    top: calc(50% - 3px);
    left:-1rem;
    border-radius:50%
}

#footer .footer-info h5.c-1 span:after,
#footer .footer-info h5.c-1 span:before{
    background-color: #028985;   
}
#footer .footer-info h5.c-2 span:after,
#footer .footer-info h5.c-2 span:before{
    background-color: #d17335;
}

#footer .footer-info h5.c-3 span:after,
#footer .footer-info h5.c-3 span:before{
    background-color: #7a49b0;
}
#footer .footer-info .footer-tel.c-1 img .cls-1,
#footer .footer-info .footer-tel.c-1 img path {
  fill: #028985 !important;
}
#footer .footer-info .footer-tel.c-2 img .cls-1 {
  fill: #d17335 !important;
}
#footer .footer-info .footer-tel.c-3 img .cls-1 {
  fill: #7a49b0 !important;
}


#footer .footer-info .footer-tel{
    display: flex;
    font-size: 1.5rem;
    align-items: center;
    font-weight: 500;
    margin-bottom:1.5rem;
    justify-content: space-between;
}
#footer .footer-info .footer-tel div{
    display: flex;
    align-items: center;
}
#footer .footer-info .footer-tel img,
#footer .footer-info .footer-tel a img{
    max-height: 20px;
    max-width: 25px;
    width: 25px;
    margin-right: 0.5rem
}

#footer .footer-info .footer-tel a{
    color:#f1f1f1;
    display: contents;
}


#footer .footer-social{
    display: flex;
    margin-top:1.5rem
}
#footer .footer-social img{
    max-width: 30px;
    margin-right: 0.5rem
}

#footer .footer-links{
    position:relative;
    list-style-type:none;
    padding-inline-start: 22px;

    font-size: 1rem;
}
#footer .footer-links:before{
    content:"";
    background-color: #d17335;
    width: 2px;
    height: calc(100% - 30px);
    position: absolute;
    top: 15px;
    left: 4px;
    border-radius:3px
}
#footer .footer-links li{
    position: relative;
    line-height: 35px;
}
#footer .footer-links li:before{
    content:"";
    background-color: #d17335;
    width: 8px;
    height: 8px;
    position: absolute;
    top: calc(50% - 3px);
    left: -21px;
    border-radius:50%
}
#footer .footer-links li a{
    color : #f1f1f1
}

#footer .row{
    width: 100%;
}
#footer .copyright{
    line-height: 30px;
    padding-top:10px;
    padding-bottom:10px;
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
#footer .copyright:before{
    content:"";
    background-color: #ffffff40;
    width: calc(100% - 2rem);
    height: 2px;
    position: absolute;
    top: 0;
    left: 1rem;
    border-radius:3px
}
</style>
